import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

export default function CircularScore({ score, size = 50 }) {
  const value = typeof score === "number" ? score : (score != null ? Number(score) : 0);

  const color = value >= 80 ? "#2e7d32" : value >= 50 ? "#ed6c02" : "#d32f2f";

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        sx={{ color: "#f5f5f5" }}
      />
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        sx={{
          color: color,
          position: "absolute",
          left: 0,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ fontWeight: 800, color: "text.primary", fontSize: "0.75rem" }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
